export default __webpack_public_path__ + "static/media/colgate-family.63daaf7f.jpg";